import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BusinessBenefits = () => {
  const benefits = [
  {
    id: 1,
    icon: "Users",
    title: "Atrae Nuevos Clientes",
    description: "Accede a miles de usuarios activos buscando descuentos en tu categoría. Aumenta tu visibilidad y atrae clientes calificados.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_157fdcf3b-1767009667539.png",
    imageAlt: "Diverse group of happy customers entering modern retail store with shopping bags and smiling faces in bright welcoming environment"
  },
  {
    id: 2,
    icon: "BarChart3",
    title: "Analíticas en Tiempo Real",
    description: "Conoce quién escanea tu código QR, cuándo lo hacen y qué descuentos son más populares. Datos completos de nombre, ID y contacto.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ecd42800-1767033343981.png",
    imageAlt: "Modern business dashboard displaying colorful analytics charts and graphs on large computer monitor in professional office setting"
  },
  {
    id: 3,
    icon: "Megaphone",
    title: "Marketing Digital Integrado",
    description: "Publica imágenes y videos de tus productos. Comparte ofertas especiales. Conecta tus redes sociales y WhatsApp directamente.",
    image: "https://images.unsplash.com/photo-1585386283478-8add9912b93f",
    imageAlt: "Business owner using smartphone to post product photos on social media with colorful merchandise display visible in background"
  },
  {
    id: 4,
    icon: "QrCode",
    title: "Código QR Único",
    description: "Recibe tu código QR personalizado al registrarte. Imprímelo, compártelo digitalmente y comienza a atraer clientes inmediatamente.",
    image: "https://images.unsplash.com/photo-1705300397099-80ba6a1ce6d8",
    imageAlt: "Close-up of printed QR code displayed on modern business counter with smartphone scanning it in professional retail environment"
  }];


  return (
    <section className="py-20 px-6 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            Beneficios para tu Negocio
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Herramientas digitales completas para hacer crecer tu negocio en Colombia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits?.map((benefit) =>
          <div
            key={benefit?.id}
            className="bg-card rounded-2xl shadow-card overflow-hidden transition-transform hover:scale-105">

              <div className="relative h-48 overflow-hidden">
                <Image
                src={benefit?.image}
                alt={benefit?.imageAlt}
                className="w-full h-full object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="flex items-center justify-center w-12 h-12 bg-primary text-primary-foreground rounded-lg">
                    <Icon name={benefit?.icon} size={24} />
                  </div>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {benefit?.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 bg-primary text-primary-foreground rounded-2xl p-8 text-center">
          <div className="max-w-3xl mx-auto space-y-4">
            <Icon name="Sparkles" size={48} className="mx-auto" />
            <h3 className="text-2xl md:text-3xl font-bold">
              Registro Gratuito para Negocios
            </h3>
            <p className="text-lg opacity-90">Sin costos de inscripción. Sin mensualidades. 

            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Check" size={20} />
                <span>Código QR gratis</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Check" size={20} />
                <span>Publicaciones ilimitadas</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Check" size={20} />
                <span>Analíticas completas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default BusinessBenefits;